import React, { useState } from 'react';
import AdminDashboard2 from './adminDashboard2';
import AdminDashboard from './adminDashboard';

const MainManagerDashboard = () => {
  const [dahboardType, setDashbaordType] = useState(1);
  return (
    <div className="h-full px-4">
      <div className="bg-[#e6e4e4] p-1 w-[500px] rounded-sm mt-2  flex">
        <button
          onClick={() => {
            setDashbaordType(1);
          }}
          className={`${
            dahboardType === 1 ? 'bg-brown  text-white' : ''
          } py-1 px-5   rounded-sm flex-1 text-center`}
        >
          Dashboard
        </button>
        <button
          onClick={() => {
            setDashbaordType(2);
          }}
          className={`${
            dahboardType === 2 ? 'bg-brown  text-white' : ''
          } py-1 px-5  rounded-sm ml-3 flex-1 text-center`}
        >
          Today Issues Dashboard
        </button>
      </div>
      <div
                 style={{
          height: `calc(100% - 50px)`,
        }}
        className=""
      >
        {dahboardType === 1 ? <AdminDashboard2 /> : <AdminDashboard />}
      </div>
    </div>
  );
};

export default MainManagerDashboard;
